<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-[9999] flex items-center justify-center px-16 py-32 pointer-events-none"
      data-testid="verify-email-modal-message"
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="message-verify-email-heading"
        class="relative w-full max-w-[480px] bg-foreground rounded-xl box-shadow-static-lg px-16 py-24 max-h-[85vh] overflow-auto pointer-events-auto"
        @mousedown.stop
        @touchstart.stop
      >
        <VerifyEmailWaiting
          :active="modelValue"
          :account-email="accountEmail"
          heading-id="message-verify-email-heading"
          heading-tag="h2"
          heading-class="text-h3"
          headline="Verify your email to send your message"
          @verified="emit('verified')"
        />
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
import VerifyEmailWaiting from '@/apps/verifyEmail/VerifyEmailWaiting.vue';

export default {
  name: 'VerifyEmailModalMessage',
  components: {
    VerifyEmailWaiting,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    accountEmail: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'verified'],
  methods: {
    emit(event: 'verified'): void {
      this.$emit(event);
    },
  },
};
</script>
